export default __webpack_public_path__ + "static/media/Screenshot (1147).9b9fec88.png";